
import { Link } from 'react-router-dom';

interface SubscriptionSuccessProps {
  planName: string;
  billingCycle: 'monthly' | 'yearly';
  reference: string;
  onClose: () => void;
}

export default function SubscriptionSuccess({ planName, billingCycle, reference, onClose }: SubscriptionSuccessProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center animate-fadeIn">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-gradient-to-br from-teal-400 to-cyan-400 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg shadow-teal-200">
          <i className="ri-check-line text-white text-4xl"></i>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2">Subscription Activated!</h2>
        <p className="text-gray-600 text-sm mb-6">
          Your <strong className="text-teal-600">{planName}</strong> plan ({billingCycle}) is now active. You can start creating unlimited events right away.
        </p>

        {/* Reference */}
        <div className="bg-gray-50 rounded-lg p-3 mb-6">
          <p className="text-xs text-gray-400 mb-1">Payment Reference</p>
          <p className="text-sm font-mono text-gray-700 break-all">{reference}</p>
        </div>

        {/* What's Next */}
        <div className="bg-teal-50 border border-teal-100 rounded-xl p-4 mb-6 text-left">
          <p className="text-sm font-semibold text-teal-800 mb-3">What&apos;s next?</p>
          <ul className="space-y-2">
            <li className="flex items-center gap-2 text-sm text-teal-700">
              <i className="ri-calendar-event-line text-teal-500"></i>
              Create your first event
            </li>
            <li className="flex items-center gap-2 text-sm text-teal-700">
              <i className="ri-share-line text-teal-500"></i>
              Add social media links to grow followers
            </li>
            <li className="flex items-center gap-2 text-sm text-teal-700">
              <i className="ri-bar-chart-line text-teal-500"></i>
              Track performance in your dashboard
            </li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <Link
            to="/create-event"
            className="flex-1 px-5 py-3 bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-sm font-semibold rounded-xl hover:from-teal-600 hover:to-cyan-600 transition-all shadow-lg whitespace-nowrap"
          >
            <i className="ri-add-line mr-1"></i>
            Create Event
          </Link>
          <Link
            to="/dashboard"
            onClick={onClose}
            className="flex-1 px-5 py-3 border border-gray-200 text-gray-700 text-sm font-semibold rounded-xl hover:bg-gray-50 transition-all whitespace-nowrap"
          >
            Go to Dashboard
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
        .animate-fadeIn { animation: fadeIn 0.3s ease-out; }
      `}</style>
    </div>
  );
}
